"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GPay = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var GPay = function GPay(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#GPay_svg__GPay_svg__clip0_20336_109075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.027 20.595v3.957h-1.33V14.78h3.526c.421-.009.84.062 1.232.207s.75.362 1.052.639c.305.26.548.578.713.934.165.355.247.74.24 1.128.01.39-.072.778-.236 1.136-.165.358-.41.678-.717.938-.617.556-1.378.833-2.284.832h-2.196v.001zm0-4.612v3.411h2.23c.244.007.487-.034.714-.121.226-.087.43-.218.6-.384.17-.155.304-.34.396-.546a1.586 1.586 0 000-1.296 1.666 1.666 0 00-.395-.546 1.74 1.74 0 00-.599-.393 1.825 1.825 0 00-.716-.126h-2.23zm8.497 1.665c.982 0 1.758.248 2.327.744.568.495.852 1.175.852 2.04v4.12H29.43v-.927h-.058c-.55.764-1.282 1.146-2.196 1.146-.78 0-1.433-.219-1.958-.655a2.108 2.108 0 01-.59-.735 1.992 1.992 0 01-.198-.903c0-.692.277-1.242.831-1.65.554-.409 1.293-.614 2.218-.615.79 0 1.44.137 1.95.41v-.288a1.364 1.364 0 00-.142-.614 1.443 1.443 0 00-.407-.497 1.94 1.94 0 00-1.283-.457c-.743 0-1.33.296-1.763.887l-1.17-.696c.643-.874 1.596-1.31 2.859-1.31zm-1.72 4.858a.954.954 0 00.115.46c.077.142.188.265.326.358.294.219.659.334 1.033.328a2.185 2.185 0 001.495-.587c.44-.391.66-.85.66-1.377-.414-.312-.992-.468-1.733-.468-.54 0-.99.123-1.351.369-.364.25-.545.553-.545.917zm12.198-4.64L33.563 27.5h-1.372l1.647-3.371-2.919-6.263h1.445l2.11 4.803h.029l2.052-4.803h1.447z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.655 19.742a6.33 6.33 0 00-.103-1.141H7.945v2.162h3.212a2.519 2.519 0 01-.41.968 2.68 2.68 0 01-.778.738v1.404h1.917c1.122-.978 1.769-2.422 1.769-4.13z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.945 25.229c1.605 0 2.956-.498 3.94-1.356L9.97 22.47c-.533.341-1.22.536-2.024.536-1.55 0-2.867-.987-3.337-2.317H2.633v1.446a5.749 5.749 0 002.192 2.258 6.209 6.209 0 003.12.835z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.608 20.689a3.187 3.187 0 010-2.15v-1.446H2.633A5.36 5.36 0 002 19.614c0 .876.217 1.739.633 2.521l1.975-1.446z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.945 16.222a3.334 3.334 0 012.281.842l1.697-1.602A5.903 5.903 0 007.945 14c-1.102 0-2.182.29-3.12.835a5.75 5.75 0 00-2.192 2.258l1.975 1.447c.47-1.33 1.787-2.318 3.337-2.318z",
    fill: "#EA4335"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "GPay_svg__GPay_svg__clip0_20336_109075"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 14)",
    d: "M0 0h36v13.5H0z"
  }))));
};

exports.GPay = GPay;
var _default = GPay;
exports.default = _default;